module.exports = __webpack_public_path__ + "img/5_AR.bd8fab58.png";